import "mapbox-gl/dist/mapbox-gl.css";
import React, { useState, useRef } from "react";
import MapGL, { Marker, MapRef, ViewState } from "react-map-gl";

import Pin from "../map/pin";
import BuildingHeightLegend from "../legends/BuildingHeightLegend";
import { defaultMapStyle } from "../map/Constants";

import { ScaleBar } from "../map/ScaleBar";
import { MapStylesMenu } from "../map/MapStylesMenu";

type ClaimShowMapProps = {
  latitude: number;
  longitude: number;
};

const TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;

export const ClaimShowMap: React.FC<ClaimShowMapProps> = ({ latitude, longitude }) => {
  const [viewState, setViewState] = useState({
    latitude: latitude,
    longitude: longitude,
    zoom: 17,
  });

  const [mapStyle, setMapStyle] = useState(defaultMapStyle); // when hazard config has mayStyle

  const mapRef = useRef<MapRef>(null);

  const onMove = (viewState: ViewState) => {
    setViewState(viewState);
  };

  return (
    <MapGL
      {...viewState}
      mapboxAccessToken={TOKEN}
      style={{ width: "100%", height: "100%" }}
      mapStyle={mapStyle}
      onMove={(evt) => onMove(evt.viewState)}
      ref={mapRef}
    >
      <BuildingHeightLegend mapStyle={mapStyle} />

      <Marker longitude={longitude} latitude={latitude}>
        <Pin size={20} />
      </Marker>

      <MapStylesMenu setMapStyle={setMapStyle}></MapStylesMenu>

      <ScaleBar zoom={viewState.zoom} />
    </MapGL>
  );
};
